import styled from 'styled-components';
import variables from '../../../../styles/variables';

export const DeviceInfoWrapper = styled.div`
  width: 50%;
  order: 2;
  background-color: rgba(216, 216, 216, 0.25);
  padding: 45px 30px;
  float: right;
  clear: right;
  @media screen and (min-width: 769px) and (max-width: 1024px) {
    width: 40%;
    padding: 30px ${variables.mobileLayoutPadding}rem;
  }
  @media screen and (max-width: 768px) {
    margin-top: 30px;
    width: 100%;
    padding: ${variables.mobileLayoutPadding}rem;
    float: none;
    clear: none;
  }
  div.buttonWrapper {
    display: flex;
    justify-content: center;
    margin-bottom: 30px;
  }
`;

export const PhoneTitle = styled.h1`
  margin-bottom: 100px;
  width: 100%;
  text-transform: none;
  @media screen and (min-width: 641px) and (max-width: 1024px) {
    font-size: 30px;
  }
  @media screen and (max-width: 640px) {
    font-size: 20px;
    margin-bottom: 75px;
  }
`;

export const TitleText = styled.p`
  font-size: 32px;
  font-weight: 600;
  line-height: 1.56;
  color: ${variables.colorBlack};
  margin-bottom: 50px;
  @media screen and (min-width: 641px) and (max-width: 1024px) {
    font-size: 24px;
  }
  @media screen and (max-width: 640px) {
    font-size: 18px;
    margin-bottom: 30px;
  }
`;

export const BodyText = styled.p`
  font-size: 24px;
  font-weight: 600;
  line-height: 2.08;
  color: ${variables.colorBlack};
  margin-bottom: 100px;
  span {
    color: ${variables.colorRed};
  }
  @media screen and (min-width: 641px) and (max-width: 1024px) {
    font-size: 20px;
  }
  @media screen and (max-width: 640px) {
    font-size: 14px;
    margin-bottom: 50px;
  }
`;
